import { parentTreeItem } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"

// Comments only exist at schedule level or lower (schedule / task / introduction); each locates from
// its schedulePath in the loaded regime tree.
const SCHEDULE_ANCHOR_TYPES = new Set(["schedule", "task", "intro"])

// The location breadcrumb ("Regime • Facility • Folder") + schedule code for a comment's anchored
// node. The breadcrumb is the PARENT path — the anchor's own label (schedule title / folder name) is
// shown separately in the header — so a folder comment reads "00-Ground Floor … 📍 Regime • Facility".
export function resolveCommentLocation(comment, treeIndex) {
    const type = comment?.anchor?.type
    const nodeId = getAnchorNodeId(comment, type)
    const node = nodeId ? treeIndex?.retrieve?.(nodeId) : null
    if (!node) return { location: "", code: "" }
    return {
        location: buildBreadcrumb(node[parentTreeItem]),
        code: SCHEDULE_ANCHOR_TYPES.has(type) ? node.code ?? "" : "",
    }
}

function getAnchorNodeId(comment, type) {
    if (SCHEDULE_ANCHOR_TYPES.has(type)) return comment?.schedulePath
    return null
}

// Walk up from `startNode`, collecting folder/facility labels until the regime (PlanRoot), whose
// stage-prefix-stripped label becomes the first segment.
function buildBreadcrumb(startNode) {
    const labels = []
    let regime = ""
    let current = startNode
    let depth = 0
    while (current && depth < 25) {
        if (current[PlanRoot]) {
            regime = cleanStageLabel(current.label)
            break
        }
        if (current.label) labels.unshift(current.label)
        current = current[parentTreeItem]
        depth++
    }
    return [regime, ...labels].filter(Boolean).join(" • ")
}

function cleanStageLabel(label) {
    return `${label ?? ""}`.replace(/^(?:Live|Ready|Publish):\s*/, "").trim()
}
